
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__login",
  "use": "icon__login-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20\" id=\"icon__login\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M.5 0h20v20H.5z\" /><path d=\"M10.5 1.25c4.822 0 8.75 3.928 8.75 8.75s-3.928 8.75-8.75 8.75c-3.954 0-7.306-2.64-8.386-6.25l1.311.001A7.492 7.492 0 0 0 10.5 17.5c4.15 0 7.5-3.35 7.5-7.5s-3.35-7.5-7.5-7.5a7.492 7.492 0 0 0-7.075 5h-1.31c1.077-3.608 4.43-6.25 8.385-6.25zm-.412 4.375 4.165 4.336-4.165 4.336-.897-.86 2.719-2.84H2.035v-1.25h9.9L9.19 6.484l.897-.86z\" fill=\"currentColor\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconLoginIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__login" {...restProps} />
    })
  